<template>
    <div class="content" v-if="bPotNumber" @click.stop="getShow">
        <div class="seach_cont">
            <div class="search">
                <img
                    src="@/assets/images/ant/search.png"
                    alt=""
                    @click="searchChange"
                />
                <input
                    type="text"
                    name=""
                    id=""
                    v-model="code"
                    @input="searchChange"
                />
            </div>
            <div class="list">
                <pull-to
                    :distance-index="3"
                    :top-load-method="downRefresh"
                    :bottom-load-method="upRefresh"
                    :is-bottom-bounce="true"
                    bottom-block-height:0
                    top-block-height:0
                >
                    <div class="item" v-for="(item,index) in arrNumber" :key="index" @click="inputText(item.contactcode)">{{item.contactcode}}</div>
                </pull-to>
            </div>
        </div>
    </div>
</template>
<script>
import PullTo from "vue-pull-to";
import oDetail from "@/js/detail.js";
export default {
    components: {
        PullTo,
    },
    props:{
        bPotNumber:{
            type:Boolean,
            default:false,
        }
    },
    data() {
        return {
            nPage: 0,
            code: "", //搜索编码
            arrNumber:[],//编码列表
            isToEnd:false,
        };
    },
    created() {
        // $init(() => {
        //     this.getNumber();
        // });
    },
    methods: {
        inputText(e){
            this.$emit('inputText',e)
            this.$emit('update:bPotNumber',false)
        },
        getShow(){
            this.$emit('update:bPotNumber',false)
        },
        //合同编码
        getNumber(callback) {
            let _that = this;
            let data = {
                page: _that.nPage,
                row: 10,
                code: _that.code,
            };
            oDetail.getNumber(data).then((res) => {
                if(res.result.lists.length<10&&_that.nPage==0){
                    _that.isToEnd = true;
                }
                if(res.result.lists.length==0){
                    _that.$toast("没有更多了！");
                     _that.isToEnd = true;
                }
                _that.arrNumber = _that.arrNumber.concat(res.result.lists);
                callback && callback();
            });
        },
        //节流函数防抖
        debounce(fn, delay) {
            let context = this; // this指向发生变化，需要提出来
            let args = arguments;
            return (function() {
                if (context.timer) {
                    clearTimeout(context.timer);
                }
                context.timer = setTimeout(() => {
                    fn.apply(context, args);
                }, delay);
            })(); // 注意:我加了()
        },
        searchChange(){
            let _that = this;
            _that.nPage = 0;
            _that.arrNumber = [];
            _that.isToEnd = false;
            _that.debounce(()=>{
                _that.getNumber();
            },300)
        },
        //下拉
        downRefresh(loaded) {
            this.isToEnd = false;
            this.arrNumber = [];
            this.nPage = 0;
            this.getNumber(() => {
                loaded("done");
            });
        },
        // 上拉加载
        upRefresh(loaded) {
            if (!this.isToEnd) {
                this.nPage++;
                this.getNumber(() => {
                    loaded("done");
                });
            } else {
                loaded("done");
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.781);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.5s ease forwards;
    .seach_cont {
        width: 80%;
        height: 800px;
        background: #fff;
        border-radius: 20px;
        padding: 30px;
        box-sizing: border-box;
        .list {
            width: 100%;
            height: calc(800px - 123px);
            margin-top: 30px;
            overflow: hidden;
            .item {
                width: 100%;
                height: 70px;
                border: 2px solid rgb(47, 127, 237);
                border-radius: 10px;
                display: flex;
                align-items: center;
                padding: 0 20px;
                box-sizing: border-box;
                font-size: 30px;
                margin-bottom: 30px;
            }
        }
        .search {
            // margin-top: 40px;
            border-width: 2px;
            border-color: rgb(47, 127, 237);
            border-style: solid;
            width: 100%;
            height: 63px;
            border-radius: 30px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            background: #fff;
            img {
                width: 34px;
                height: 34px;
                flex-shrink: 0;
                margin-right: 20px;
            }
            input {
                width: 100%;
                font-size: 26px;
                color: rgb(45, 45, 45);
                background: transparent;
            }
        }
    }
}
@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
